import React from "react";

// Mapping the statuses to index positions
const statusSteps = ["Order Confirmed", "Shipped", "Delivered"];

// Determine index safely or return invalid index
const getCurrentStepIndex = (status) => {
  switch (status) {
    case "1":
      return 0; // Order Confirmed
    case "2":
      return 1; // Shipped
    case "3":
      return 2; // Delivered
    default:
      return -1; // Invalid statuses like "0" or "4"
  }
};

const ProgressBar = ({ orderStatus }) => {
  const currentStepIndex = getCurrentStepIndex(orderStatus);

  return (
    <div className="relative m-5 flex items-center w-full max-w-[600px]">
      {statusSteps.map((step, index) => {
        // Determine if the index should show progress
        const isCompleted = currentStepIndex !== -1 && index <= currentStepIndex;
        const isCurrent = currentStepIndex !== -1 && index === currentStepIndex;

        return (
          <React.Fragment key={index}>
            {/* Step */}
            <div className="relative flex flex-col items-center">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center ${
                  isCompleted ? "bg-blue-200 animate-pulse" : "bg-gray-300"
                }`}
              >
                <div
                  className={`rounded-full w-3 h-3 ${
                    isCompleted ? "bg-blue-600" : "bg-gray-500"
                  }`}
                ></div>
              </div>
              <span
                className={`absolute top-8 text-xs text-center md:text-sm font-medium ${
                  isCurrent ? "text-blue-600" : "text-gray-500"
                }`}
              >
                {step}
              </span>
            </div>

            {/* Line Between Steps */}
            {index < statusSteps.length - 1 && (
              <div
                className={`flex-grow h-0.5 ${
                  currentStepIndex !== -1 && index < currentStepIndex
                    ? "bg-blue-500"
                    : "bg-gray-300"
                }`}
              ></div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressBar;



